@keyframes dialogEnter {
  from {
    opacity: 0;
    transform: translate(-50%, -50%) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%) scale(1);
  }
}

.dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  background-color: var(--tuna-surface-elevated);
  color: var(--tuna-content-primary);
  border-radius: var(--tuna-shape-borderRadius);
  box-shadow: var(--tuna-shadow-4);
  max-height: calc(100% - 64px);
  max-width: 600px;
  width: calc(100% - 64px);
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  outline: 0;
  z-index: var(--tuna-zIndex-modal);
  animation: dialogEnter 200ms ease-out;
}

.fullScreen {
  margin: 0;
  max-height: none;
  max-width: none;
  width: 100%;
  height: 100%;
  border-radius: 0;
}

.maxWidthXs {
  max-width: 444px;
}
.maxWidthSm {
  max-width: 600px;
}
.maxWidthMd {
  max-width: 900px;
}
.maxWidthLg {
  max-width: 1200px;
}
.maxWidthXl {
  max-width: 1536px;
}
.maxWidthNone {
  max-width: none;
}

.title {
  padding: 16px 24px;
  font-size: var(--tuna-typography-fontSize-2xl);
  font-weight: 500;
  line-height: 1.6;
}

.content {
  flex: 1 1 auto;
  padding: 20px 24px;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
}

.actions {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 8px;
}

@media (prefers-reduced-motion: reduce) {
  .dialog {
    animation: none !important;
  }
}
